export default __webpack_public_path__ + "static/media/8.89fc62fd.png";